export default "__VITE_ASSET__DxuwRjYb__"